export default {
    name: 'QField',
    props: {
        type: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        labelFor: {
            type: String,
            default: ''
        },
        labelSize: {
            type: String, // is-small, is-medium, is-large
            default: ''
        },
        labelClass: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        status: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            newType: this.type,
            newMessage: this.message,
            hasClassField: true // Used internally by <q-input>
        };
    },
    watch: {
        // Set internal type when prop change.
        type(value) {
            this.newType = value;
        },
        // Set internal message when prop change.
        message(value) {
            this.newMessage = value;
        }
    }
};
